export interface VerifySsnRequest {
  /** Order uuid */
  id: string;
  /** Last four digits of the SSN */
  ssn_last_four: string;
  /** Override for the patient-record first name */
  first_name?: string | null;
  /** Override for the patient-record last name */
  last_name?: string | null;
  /** Override for the patient-record date of birth (e.g. "1990-01-31") */
  date_of_birth?: string | null;
  /** Override for the patient-record phone, 10 digits (e.g. "2065551111") */
  phone_number?: string | null;
}

export enum VerifySsnStatus {
  SUCCESS = "success",
  ERROR = "error",
  TECHNICAL_ERROR = "technical_error",
  /** Vouched rejected the phone number, so no identity check was performed. */
  INVALID_REQUEST_PHONE_NUMBER = "invalid_request_phone_number",
}

/** Vendor CIP match results. Present only when status is "error". */
export interface VerifySsnCip {
  ssn_match: boolean | null;
  name_match: boolean | null;
  dob_match: boolean | null;
}

/** The values the verification was performed with. Present only when status is "error". */
export interface VerifySsnSubmitted {
  first_name: string;
  last_name: string;
  /** e.g. "+12065551111" */
  phone: string;
  /** e.g. "1990-01-31" */
  date_of_birth: string;
}

export interface VerifySsnResponse {
  status: VerifySsnStatus;
  /**
   * Present only when status is "error": vendor CIP match results as recorded.
   * null means the check was not performed.
   */
  cip?: VerifySsnCip | null;
  /** Present only when status is "error": the values the verification was performed with. */
  submitted?: VerifySsnSubmitted;
  /** Remaining verification attempts before the SSN path is exhausted. */
  attempts_left?: number;
}
